<template>
  <a class="location-search-infowindow" :href="data.url" @mouseover="$emit('mouseover', data.id)" @mouseout="$emit('mouseout', null)">
    <div class="location-search-infowindow__text" v-if="data.content">
      <div class="location-search-infowindow__types" v-if="data.property_type">{{ data.content.property_type }}</div>
      <h3 class="location-search-infowindow__heading">{{ data.content.name }}</h3>
      <div class="location-search-infowindow__types"><span v-for="type in data.content.types">{{ type }}</span></div>
      <div class="location-search-card__brands">
        <span class="location-search-card__brand active" :key="brand" v-for="brand in data.content.brands">{{ brand }}</span>
      </div>
      <address class="location-search-infowindow__address">
        <span class="location-search-infowindow__address-address">{{ data.content.address }}</span><br>
        <span class="location-search-infowindow__address-city">{{ data.content.city }}</span><span v-if="data.content.city && data.content.state">,</span>
        <span class="location-search-infowindow__address-state">{{ data.content.state }}</span>
        <span class="location-search-infowindow__address-zip">{{ data.content.zip }}</span>
      </address>
      <div class="location-search-infowindow__phone">
        <a :href="'tel:' + data.content.phone"
          v-if="data.content.phone">{{ formattedPhone }}</a>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    computed: {
      filteredBrands() {
        return this.$store.state.filters.brands;
      },
      formattedPhone() {
        var match = this.data.content.phone.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
          return '(' + match[1] + ') ' + match[2] + '-' + match[3]
        }
      },
    }
  };
</script>
